<template>
  <div class="callback-messenger-email">
    <label for="callback-messenger-email">Email</label>
    <input
      id="callback-messenger-email"
      type="email"
      v-model="email"
      required
      @input="$emit('update:modelValue', $event.target.value)"
      class="input field__input input-email-mask"
      :class="{ 'input-email-mask--error': invalid || error }"
      placeholder="Email"
    />
    <span v-if="error" class="callback-messenger-email__error">
      {{ error }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: String,
      default: "",
    },
    invalid: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: "",
    },
  },
  emits: ["update:modelValue"],
  computed: {
    email: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
};
</script>

<style lang="scss">
.callback-messenger-email {
  display: flex;
  flex-direction: column;
  gap: 11px;

  label {
    font-weight: 500;
    font-size: 12px;
    line-height: 120%;
  }

  .input-email-mask {
    border-radius: 100px;
    padding: 18px 16px 16px 16px;
    height: 58px;
    font-size: 16px;
    font-weight: 500;
    background: #ff0020;
    border: 1px solid #ffffff70;
    transition: border 0.2s ease;

    &:hover {
      border: 1px solid #ffffff;
    }

    &--error {
      border-color: #fff;
    }
  }

  &__error {
    font-weight: 500;
    font-size: 12px;
    line-height: 120%;
    color: #fff;
  }

  input::placeholder {
    font-size: 16px;
    font-weight: 500;
    color: #ffffff50;
  }

  .input-email-mask:focus {
    border: 1px solid #ffffff;
    outline: none;
  }
}
</style>
